import Vue from "vue";
import VueResource from "vue-resource";

Vue.use(VueResource);

export default {
  namespaced: true,
  state: {
    quiz: {},
    sequenceQuestions: [],
    currentQuestion: {},
    type_response: "",
    responses: [],
    amountQuestion: 0
  },
  mutations: {
    updateQuiz(state, payload) {
      state.quiz = {
        ...state.quiz,
        ...payload
      };
    },
    updateQuestion(state, payload) {
      state.currentQuestion = payload;
    },
    updateSequence(state, payload) {
      state.sequenceQuestions = payload;
    },
    updateAmountQuestions(state, payload) {
      state.amountQuestion = payload;
    },
    clearResponse(state, payload) {
      state.responses = payload;
    },
    updateResponse(state, payload) {
      const resps = state.responses.filter(
        val => val.question != payload.question
      );

      state.responses = [...resps, payload];
    },
    updateTypeQuestion(state, payload) {
      state.type_response = payload;
    }
  },
  actions: {
    async getQuiz({ commit }, payload) {
      try {
        const resp = await Vue.http.get(`quizzes?search=uuid:${payload}`);

        const [quiz] = resp.body.data.quizzes;

        console.log(quiz);

        commit("updateQuiz", quiz);
        return quiz;
      } catch (e) {
        return e;
      }
    },
    clearStore({ commit }, payload) {
      commit("updateQuestion", []);
      commit("updateSequence", []);
      commit("updateAmountQuestions", 0);
      commit("clearResponse", []);
      commit("updateTypeQuestion", "");
    }
  },
  getters: {
    currentResp: state => {
      const resps = {
        LINER_SCALE: {
          name: "v-linear-scale",
          params: {
            min: state.currentQuestion.response[0],
            max: state.currentQuestion.response[1]
          }
        },
        BOOLEAN: {
          name: "v-boolean",
          params: {}
        },
        LONG_ANSWER: {
          name: "v-long-answer"
        },
        SHORT_ANSWER: {
          name: "v-short-answer"
        },
        CHECK_BOXES: {
          name: "v-mult-check"
        },
        CHOICES: {
          name: "v-mult-check"
        }
      };

      return resps[state.currentQuestion.type_response];
    }
  }
};
